import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Toaster, toast } from "react-hot-toast";
import {
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button as MuiButton,
    Tooltip,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReview } from '../../Redux/Reducers/ReviewCourseReducer';
import { usePermissions } from '../../context/AuthContext';

function GenericReviewList() {
    const { can } = usePermissions();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [selectedReviewId, setSelectedReviewId] = useState(null);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    const reviewData = useSelector((state) => state?.ReviewCourseReducer?.review || []);
    const status = useSelector((state) => state?.ReviewCourseReducer?.status);
    const pagination = useSelector((state) => state?.ReviewCourseReducer?.pagination);

    const GenericReviewData = reviewData?.flatMap((item, index) =>
        item?.reviews?.map((review) => ({
            id: review._id,
            serialNo: paginationModel.page * paginationModel.pageSize + index + 1,
            comment: review.comment,
            description: review.description,
            rating: review.rating,
            parentId: item._id,
            createdAt: item.createdAt
                ? new Date(item.createdAt).toLocaleString()
                : "",
            updatedAt: item.updatedAt
                ? new Date(item.updatedAt).toLocaleString()
                : "",
        }))
    ) || [];

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
    const [filterModel, setFilterModel] = useState({
        items: [],
        quickFilterExcludeHiddenColumns: true,
        quickFilterValues: [''],
    });

    useEffect(() => {
        const { page, pageSize } = paginationModel;
        dispatch(fetchReview({ page: page + 1, limit: pageSize }));
    }, [paginationModel, dispatch]);

    const handleClickOpen = (reviewId) => {
        setSelectedReviewId(reviewId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedReviewId(null);
    };

    const handleDelete = async () => {
        if (selectedReviewId) {
            try {
                const token = localStorage.getItem("vedhvidhi-admin-token");
                const { page, pageSize } = paginationModel;
                await axios.delete(`${process.env.REACT_APP_BASEURL}/admin/review/${selectedReviewId}`, {
                    headers: {
                        Authorization: ` ${token}`,
                    },
                });
                toast.success("Review deleted successfully!");
                dispatch(fetchReview({ page: page + 1, limit: pageSize }));
                handleClose();
            } catch (error) {
                console.error("Error deleting Review:", error);
                toast.error("Failed to delete Review!");
            }
        }
    };

    const columns = [
        { field: 'serialNo', headerName: 'S.No', width: 100 },
        { field: 'comment', headerName: 'Comment', width: 300 },
        { field: 'rating', headerName: 'Rating', width: 150 },
        { field: 'description', headerName: 'Description', width: 300 },
        { field: 'createdAt', headerName: 'Created At', width: 200 },
        { field: 'updatedAt', headerName: 'Updated At', width: 200 },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            renderCell: ({ row }) => (
                <div>
                    {can('generic_reviews:edit') && (
                        <Tooltip title="Edit Review">
                            <IconButton component={Link} to={`/review-edit/${row?.parentId}`}>
                                <i className="icofont-edit text-info"></i>
                            </IconButton>
                        </Tooltip>
                    )}
                    {can('generic_reviews:delete') && (
                        <Tooltip title="Delete Review">
                            <IconButton component="button" onClick={() => handleClickOpen(row?.parentId)}>
                                <i className="icofont-ui-delete text-danger"></i>
                            </IconButton>
                        </Tooltip>
                    )}
                </div>
            ),
        },
    ];

    return (
        <>
            <Toaster />
            <div className="body d-flex py-1">
                <div className="container-xxl">
                    <PageHeader1
                        pagetitle="Generic Review List"
                        righttitle="Add Review"
                        link="/genericreview-add"
                        routebutton={can('generic_reviews:add')}
                    />
                    <div className="row g-0 mb-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <Box sx={{ width: 1 }}>
                                        <Box sx={{ height: 500 }}>
                                            <DataGrid
                                                rows={GenericReviewData}
                                                columns={columns}
                                                getRowId={(row) => row.id}
                                                slots={{ toolbar: GridToolbar }}
                                                filterModel={filterModel}
                                                onFilterModelChange={(newModel) => setFilterModel(newModel)}
                                                slotProps={{ toolbar: { showQuickFilter: true } }}
                                                columnVisibilityModel={columnVisibilityModel}
                                                onColumnVisibilityModelChange={(newModel) =>
                                                    setColumnVisibilityModel(newModel)
                                                }
                                                disableRowSelectionOnClick
                                                loading={status === 'loading'}
                                                paginationMode="server"
                                                rowCount={pagination?.totalDocs || 0}
                                                pageSizeOptions={[10, 25, 50, 100]}
                                                paginationModel={paginationModel}
                                                onPaginationModelChange={setPaginationModel}
                                            />
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Delete Confirmation</DialogTitle>
                    <DialogContent>
                        <DialogContentText>Are you sure you want to delete this Review?</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <MuiButton onClick={handleClose}>
                            Cancel
                        </MuiButton>
                        <MuiButton onClick={handleDelete} color="error">
                            Delete
                        </MuiButton>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );
}

export default GenericReviewList;